module.exports = ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:50px}"


// WEBPACK FOOTER //
// webpack://ClassicEditor/ckeditor5-image/theme/image.css